import { LocationDescriptorObject } from 'history';
import { EnhancedLocationDescriptor } from '../../mainv3/routes';
import { GlobalStatesV3 } from '../../commonv3/states/GlobalStatesV3';

/**
 * アカウント用のルーティングパスを生成する
 * 環境によってページがホストされるパスが変わるので、環境によらず正しいパスを返すようにする。
 * 例：プロフィールページのパス
 * - staging, production : account.shelikes.jp/profile
 * - local: localhost:3001/account/profile
 * @param path
 * @param params
 */
function accountPath(path: string, params: Partial<LocationDescriptorObject> = {}): EnhancedLocationDescriptor {
    const pathname = GlobalStatesV3.routing.location.pathname.startsWith('/account') ? `/account/${path}` : `/${path}`;
    return {
        pathname,
        stringify() {
            const search = this.search ? `?${this.search}` : '';
            const hash = this.hash ? this.hash : '';
            return `/${path}${hash}${search}`;
        },
        toAbsolute() {
            return `${location.origin}${this.stringify()}`;
        },
        ...params,
    };
}

export const AccountRoutes = {
    homeLocation() {
        return accountPath('home_location');
    },
    plan() {
        return accountPath('plans');
    },
    payments() {
        return accountPath('payments');
    },
    password() {
        return accountPath('password');
    },
    email() {
        return accountPath('email');
    },
    profile() {
        return accountPath('profile');
    },
    reservations() {
        return accountPath('reservations');
    },
    signOut() {
        return accountPath('sign_out');
    },
};
